
import type { Editor } from '@ckeditor/ckeditor5-core';
import type { Users } from '@ckeditor/ckeditor5-collaboration-core';
import type { RevisionData, RevisionHistory } from '@ckeditor/ckeditor5-revision-history';
//import { AppData } from './revisionData';
import { TrackChanges } from '@ckeditor/ckeditor5-track-changes';
import { CommentsRepository } from '@ckeditor/ckeditor5-comments';
import { UserProfile } from 'src/app/core/models/user';
import { AppData, AppDataWithoutRevision, ckUses } from 'src/app/core/models/ckEditor/revisionData';


let appData: AppData = new AppData();
let appDataWithoutRevision: AppDataWithoutRevision = new AppDataWithoutRevision();

export function UsersInitWithOutRevision(user: UserProfile) {
	return class UsersInit {
		public editor: Editor;
		public constructor(editor: Editor) {
			this.editor = editor;
		}

		static get pluginName() {
			return 'UsersInit';
		}

		static get requires() {
			return ['Users'];
		}

		init() {
			const users = this.editor.plugins.get('Users') as Users;
			if (user) {
				appDataWithoutRevision.userId = user.userId.toString();
				appDataWithoutRevision.user.name = user.fullName;
			}
			users.addUser(appDataWithoutRevision.user);
			users.defineMe(appDataWithoutRevision.user.id);
		}
	}

}


// export function UsersInitWithRevision(user: UserProfile,editorUsers: string[]) {
// 	return class UsersInitWithRevision {

// 		public editor: Editor;
// 		public constructor(editor: Editor) {
// 			this.editor = editor;
// 		}

// 		static get pluginName() {
// 			return 'UsersInit';
// 		}

// 		static get requires() {
// 			return ['Users'];
// 		}

// 		init() {
// 			const users = this.editor.plugins.get('Users') as Users;
// 			for(let i=0;i<editorUsers.length;i++){
// 				if (editorUsers[i]) {
// 					let ob = new ckUses();
// 					ob.id = editorUsers[i];
// 					ob.name = editorUsers[i];
// 					users.addUser(ob);
// 				}
// 			}
// 			// editorUsers.forEach(element => {
// 			// 	if (element) {
// 			// 		let ob = new ckUses();
// 			// 		ob.id = element;
// 			// 		ob.name = element;
// 			// 		users.addUser(ob);
// 			// 	}
// 			// });
// 			users.defineMe(user.fullName);
// 		}
// 	}

// }

// export function CommentsAdapter(loginUser: UserProfile, appId: string) {
// 	return class CommentsAdapter {
// 		public editor: Editor;
// 		public constructor(editor: Editor) {
// 			this.editor = editor;
// 		}
// 		static get requires() {
// 			return ['CommentsRepository'];
// 		}
// 		async init() {
// 			appData.noteId = appId;
// 			//const usersPlugin = this.editor.plugins.get('Users') as Users;
// 			const commentsRepositoryPlugin = this.editor.plugins.get(
// 				'CommentsRepository'
// 			) as CommentsRepository;
// 			// Load the users data.

// 			// for (const user of appData.users) {
// 			// 	if (user) {
// 			// 		//user.id = loginUser.userId.toString();
// 			// 		user.name = loginUser.fullName;
// 			// 	}
// 			// 	usersPlugin.addUser(user);
// 			// }
// 			// usersPlugin.addUser({
// 			// 	id: loginUser.userId.toString(),
// 			// 	name: loginUser.fullName
// 			// });
// 			// usersPlugin.defineMe(appData.userId);
// 			commentsRepositoryPlugin.adapter = {
// 				addComment(data: any) {
// 					let commentsString: any = localStorage.getItem('userComment-' + appData.noteId);
// 					let addReply = JSON.parse(commentsString)

// 					const mainComment = addReply?.find((comment: { mainComment: { threadId: any; }; }) => comment.mainComment.threadId === data.threadId);
// 					mainComment.replies.push({ data });
// 					localStorage.setItem('userComment-' + appData.noteId, JSON.stringify(addReply));

// 					// Write a request to your database here. The returned `Promise`
// 					// should be resolved when the request has finished.
// 					// When the promise resolves with the comment data object, it
// 					// will update the editor comment using the provided data.
// 					return Promise.resolve({
// 						commentId: data.commentId,
// 						createdAt: new Date(), // Should be set on the server side.
// 					});
// 				},
// 				updateComment(data) {
// 					// Retrieve existing data from localStorage
// 					const existingMainDataString = localStorage.getItem('userComment-' + appData.noteId);
// 					// Parse existing data into an array or initialize an empty array if no data exists
// 					const existingMainData = existingMainDataString ? JSON.parse(existingMainDataString) : [];
// 					existingMainData.forEach((item: any) => {
// 						if (item.mainComment.threadId == data.threadId) {
// 							item.mainComment.comments.forEach((element: any) => {
// 								if (element.commentId == data.commentId) {
// 									element.content = data.content;
// 								}
// 							});

// 						}
// 					})
// 					localStorage.setItem("userComment-" + appData.noteId, JSON.stringify(existingMainData));
// 					return Promise.resolve();
// 				},
// 				removeComment(data) {
// 					// Write a request to your database here. The returned `Promise`
// 					// should be resolved when the request has finished.
// 					return Promise.resolve();
// 				},
// 				addCommentThread(data: any) {
// 					// Sample data structure
// 					const newCommentThread = {
// 						mainComment: data,
// 						replies: [],
// 					};
// 					// Retrieve existing data from localStorage
// 					const existingMainDataString = localStorage.getItem('userComment-' + appData.noteId);
// 					// Parse existing data into an array or initialize an empty array if no data exists
// 					const existingMainData = existingMainDataString ? JSON.parse(existingMainDataString) : [];
// 					// Append the new data to the array
// 					existingMainData.push(newCommentThread);
// 					// Store the JSON string in local storage with a key (e.g., "UserComment")
// 					localStorage.setItem("userComment-" + appData.noteId, JSON.stringify(existingMainData));
// 					// CkEditorComponent.prototype.saveData();
// 					// Write a request to your database here. The returned `Promise`
// 					// should be resolved when the request has finished.
// 					return Promise.resolve({
// 						threadId: data.threadId,
// 						comments: data.comments?.map((comment: { commentId: any }) => ({
// 							commentId: comment.commentId,
// 							createdAt: new Date(),
// 						})), // Should be set on the server side.
// 					});
// 				},
// 				getCommentThread(data) {


// 					let commentsString = localStorage.getItem('userComment-' + appData.noteId);
// 					let comments: any = [];
// 					if (commentsString !== null) {

// 						comments = JSON.parse(commentsString);

// 						// const thread = comments.find(thread => thread.threadId === data.threadId);
// 						const thread = comments?.find((thread: { mainComment: { threadId: string; }; }) => thread.mainComment.threadId === data.threadId);

// 						if (thread) {
// 							// Return the dynamic comment data
// 							return Promise.resolve({
// 								threadId: thread.mainComment.threadId,
// 								comments: thread.mainComment.comments?.map((comment: { commentId: any; authorId: any; content: any; createdAt: any; attributes: any; }) => ({
// 									commentId: comment.commentId,
// 									authorId: comment.authorId,
// 									content: comment.content,
// 									createdAt: comment.createdAt,
// 									attributes: comment.attributes,
// 								})),
// 								context: {
// 									type: 'text',
// 									value: '',
// 								},
// 								unlinkedAt: null,
// 								resolvedAt: null,
// 								resolvedBy: null,
// 								attributes: {},
// 								isFromAdapter: true,
// 							});
// 						}
// 					}

// 					// Write a request to your database here. The returned `Promise`
// 					// should resolve with the comment thread data.
// 					return Promise.resolve({
// 						threadId: data.threadId,
// 						comments: [
// 							{
// 								commentId: '',
// 								authorId: 'u2',
// 								content: '<p>comments?</p>',
// 								createdAt: new Date(),
// 								attributes: {},
// 							},
// 						],
// 						// It defines the value on which the comment has been created initially.
// 						// If it is empty it will be set based on the comment marker.
// 						context: {
// 							type: 'text',
// 							value: '',
// 						},
// 						unlinkedAt: null,
// 						resolvedAt: null,
// 						resolvedBy: null,
// 						attributes: {},
// 						isFromAdapter: true,
// 					});
// 				},
// 				updateCommentThread(data) {
// 					// Write a request to your database here. The returned `Promise`
// 					// should be resolved when the request has finished.
// 					return Promise.resolve();
// 				},
// 				resolveCommentThread: (data) => {
// 					// Retrieve existing data from localStorage
// 					const existingMainDataString = localStorage.getItem('userComment-' + appData.noteId);
// 					// Parse existing data into an array or initialize an empty array if no data exists
// 					const existingMainData = existingMainDataString ? JSON.parse(existingMainDataString) : [];
// 					const newUpdatedCommentArr = existingMainData.filter((item: any) => item.mainComment.threadId !== data.threadId);
// 					localStorage.setItem("userComment-" + appData.noteId, JSON.stringify(newUpdatedCommentArr));
// 					// localStorage.setItem('editorData-'+ appData.noteId, this.editor?.data.get());

// 					// Write a request to your database here. The returned `Promise`
// 					// should be resolved when the request has finished.
// 					return Promise.resolve({
// 						threadId: data.threadId,
// 						resolvedAt: new Date(), // Should be set on the server side.
// 						resolvedBy: loginUser.fullName, // Should be set on the server side.
// 					});
// 				},

// 				reopenCommentThread(data) {
// 					// Write a request to your database here. The returned `Promise`
// 					// should be resolved when the request has finished.
// 					return Promise.resolve();
// 				},

// 				removeCommentThread(data) {
// 					const existingMainDataString = localStorage.getItem('userComment-' + appData.noteId);
// 					// Parse existing data into an array or initialize an empty array if no data exists
// 					const existingMainData = existingMainDataString ? JSON.parse(existingMainDataString) : [];
// 					const newUpdatedCommentArr = existingMainData.filter((item: any) => item.mainComment.threadId !== data.threadId);
// 					localStorage.setItem("userComment-" + appData.noteId, JSON.stringify(newUpdatedCommentArr));
// 					return Promise.resolve();
// 				}
// 			};
// 		}
// 	}
// }
// //export class TrackChangesAdapter {
// export function TrackChangesAdapter(appId: string,userInfo:UserProfile) {
// 	return class TrackChangesAdapter {
// 		public editor: Editor;
// 		public constructor(editor: Editor) {
// 			this.editor = editor;
// 		}
// 		async init() {
// 			appData.noteId = appId;
// 			const trackChangesPlugin = this.editor.plugins.get(
// 				'TrackChanges'
// 			) as TrackChanges;
// 			trackChangesPlugin.adapter = {
// 				getSuggestion: (suggestionId: string): Promise<any> => {

// 					const track: any = localStorage.getItem("trackChanges-" + appData.noteId);
// 					const trackChangesArray = JSON.parse(track)
// 					const matchedSuggestion = trackChangesArray?.find((suggestion: { id: string; }) => suggestion.id === suggestionId);

// 					// Write a request to your database here.
// 					// The returned `Promise` should be resolved with the suggestion
// 					// data object when the request has finished.
// 					return Promise.resolve({
// 						id: suggestionId,
// 						type: matchedSuggestion.type,
// 						authorId:userInfo.fullName,
// 						createdAt: new Date(),
// 						data: null,
// 						attributes: {}
// 					});
// 				},

// 				addSuggestion: (suggestionData): Promise<any> => {
// 					const trachChanges = suggestionData;
// 					// Retrieve existing data from localStorage
// 					const existingMainDataString = localStorage.getItem('trackChanges-' + appData.noteId);

// 					// Parse existing data into an array or initialize an empty array if no data exists
// 					const existingMainData = existingMainDataString ? JSON.parse(existingMainDataString) : [];

// 					// Append the new data to the array
// 					existingMainData.push(trachChanges);

// 					// Store the JSON string in local storage with a key (e.g., "UserComment")

// 					localStorage.setItem("trackChanges-" + appData.noteId, JSON.stringify(existingMainData));
// 					// Write a request to your database here.
// 					// The returned `Promise` should be resolved when the request
// 					// has finished. When the promise resolves with the suggestion data
// 					// object, it will update the editor suggestion using the provided data.
// 					return Promise.resolve({
// 						createdAt: new Date(), // Should be set on the server side.
// 					});
// 				},

// 				updateSuggestion: (id, suggestionData) => {

// 					// Write a request to your database here.
// 					// The returned `Promise` should be resolved when the request
// 					// has finished.
// 					return Promise.resolve();
// 				},
// 			};
// 		}
// 	}
// }

export function RevisionHistoryAdapter(appId: string) {
	return class RevisionHistoryAdapter {
		public editor: Editor;
		public constructor(editor: Editor) {
			this.editor = editor;
		}
		static get pluginName() {
			return 'RevisionHistoryAdapter';
		}

		static get requires() {
			return ['RevisionHistory'];
		}

		async init() {
			appData.noteId = appId;
			const revisionHistory = this.editor.plugins.get('RevisionHistory') as RevisionHistory;
			revisionHistory.adapter = {
				getRevision: ({ revisionId }): Promise<any> => {
					const revision: any = localStorage.getItem("revisionHistoryData-" + appData.noteId);
					const revisionArray = JSON.parse(revision);
					const matchedRevisionId = revisionArray?.find((item: { id: string; }) => item.id === revisionId);
					return Promise.resolve(
						[]
					);
				},
				updateRevisions: (
					revisionsData: Array<RevisionData>,
					channelId: string
				): Promise<Array<RevisionData>> => {
					// Retrieve existing revision data from local storage
					const existingRevisionDataString = localStorage.getItem("revisionHistoryData-" + appData.noteId);
					const existingRevisionData = existingRevisionDataString ? JSON.parse(existingRevisionDataString) : [];

					const revisionsToAdd = revisionsData.filter((obj: { hasOwnProperty: (arg0: string) => any; }) => obj.hasOwnProperty('id'));

					// Concatenate existing and new revision data
					const updatedRevisionData = existingRevisionData.concat(revisionsToAdd);



					// Update local storage with the combined array
					localStorage.setItem("revisionHistoryData-" + appData.noteId, JSON.stringify(updatedRevisionData));
					//localStorage.setItem('editorData-' + appData.noteId, this.editor?.data.get());

					// This should be an asynchronous request to your database
					// that saves `revisionsData` and `documentData`.
					//
					// Document data should be saved each time a revision is saved.
					//
					// `revisionsData` is an array with objects,
					// where each object contains updated and new revisions.
					//
					// See the API reference for `RevisionHistoryAdapter` to learn
					// how to correctly integrate the feature with your application.
					//
					//return Promise.resolve() as Promise<any>;
					return Promise.resolve([]);
				},
			};

			// Add the revisions data for existing revisions.
			// You can either dump the revisions data straight in the source code, or
			// you can fetch the data asynchronously from your database (as this example shows).
			//
			// Note that the revisions data does not contain `diffData` property.
			// `diffData` property may be big and will be fetched on demand by `adapter.getRevision()`.
			//
			const revisionsData = await this._fetchRevisionsData();
			for (const revisionData of revisionsData) {
				revisionHistory.addRevisionData(revisionData as any);
			}
		}

		async _fetchRevisionsData() {
			const revision: any = localStorage.getItem("revisionHistoryData-" + appData.noteId);
			const revisionArray = JSON.parse(revision);
			// Make an asynchronous call to your database.
			const mappedRevisions = revisionArray?.map((revisionObj: { id: any; name: any; creatorId: any; authorsIds: any; createdAt: any; fromVersion: any; toVersion: any; }) => ({
				id: revisionObj.id,
				name: revisionObj.name,
				creatorId: revisionObj.creatorId,
				authorsIds: revisionObj.authorsIds,
				createdAt: revisionObj.createdAt,
				attributes: {},
				fromVersion: revisionObj.fromVersion,
				toVersion: revisionObj.toVersion,
			}));
			return Promise.resolve([

			]);
		}

	}
}
